import React from 'react'
import {useTranslation} from 'react-i18next'
import {Form} from 'antd'
import {observer} from 'mobx-react'
import {useInjection} from 'dna-react-ioc'
import {ModalFormFooter, Text, TitleWithStatus} from '@/components'
import {ModalContainer} from '@/components/containers'
import {EditPaymentLinkForm, TEditPaymentLinkStore} from '@/pages/PayByLink/components'
import {PayByLinkEditPaymentLinkStoreSymbol} from '@/pages/PayByLink'
import {getAmountWithCurrentCurrency, upperCaseFirstLetter} from '@/utils'
import {
    getPayByLinkPaymentStatusIconType,
    getPayByLinkPaymentStatusTagType
} from '~/code/pages/PayByLink/services'
import {NewPaymentLinkModalProps} from './props'
import styles from './styles.scss'

export const EditPaymentLinkModal: React.FC<NewPaymentLinkModalProps> = observer(
    ({injectableIdentifier}: NewPaymentLinkModalProps) => {
        const {t} = useTranslation()
        const {paymentLink, isLoading, closeEditLinkModal} = useInjection<TEditPaymentLinkStore>(
            PayByLinkEditPaymentLinkStoreSymbol
        )
        const [form] = Form.useForm()

        return (
            <ModalContainer
                className={styles.modal}
                title={
                    <TitleWithStatus
                        statusProps={{
                            status: upperCaseFirstLetter(paymentLink.status),
                            type: getPayByLinkPaymentStatusTagType(paymentLink.status),
                            iconType: getPayByLinkPaymentStatusIconType(paymentLink.status)
                        }}
                    >
                        <Text>{getAmountWithCurrentCurrency(paymentLink.amount)}</Text>
                    </TitleWithStatus>
                }
                injectableIdentifier={injectableIdentifier}
                footer={
                    <ModalFormFooter
                        formId={'editPaymentLinkForm'}
                        onCancel={() => {
                            form.resetFields()
                            closeEditLinkModal()
                        }}
                        cancelText={t('EditPaymentLinkModal.close')}
                        confirmLoading={isLoading}
                        okText={t('EditPaymentLinkModal.save')}
                    />
                }
            >
                <EditPaymentLinkForm form={form} formId={'editPaymentLinkForm'} />
            </ModalContainer>
        )
    }
)
